const Loading = () => {
    return (
        <div className="loadingio-spinner-bean-eater-grsgb3i7vfl"><div className="ldio-iyylymopdqq">
            <div><div></div><div></div><div></div></div><div><div></div><div></div><div></div></div>
        </div></div>
    )
}

export default Loading
